import { Formsy, george, observer, pr, React, RouteComponentProps, ui } from "aaa";
import { pushRoute } from "stores/RouterFunctions";
import { history } from "stores/RouterStore";
import { ChooseSIdentityLimit } from "../../common/ChooseSIdentityLimit";
import { SettingsTitleBar } from "../components/SettingsTitleBar";
import { CardTanSettingsRoutes } from "./CardTanSettingsRoutes";
import { CardTanSettingsStore } from "./CardTanSettingsStore";

type IProps = RouteComponentProps<{}> & {
    store: CardTanSettingsStore
};

export const CardTanSettingsLimit = observer(({ store }: IProps) => {
    const [isLoading, setIsLoading] = React.useState(false);

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleChangeLimit = async () => {
        try {
            setIsLoading(true);
            await store.changeLimit();
            setIsLoading(false);
        } catch (err) {
            setIsLoading(false);
            pushRoute("/error");
        }
        const isOnboardingLimitSite = history.location.pathname === CardTanSettingsRoutes.ONBOARDING_LIMIT;
        pushRoute(isOnboardingLimitSite ? CardTanSettingsRoutes.ONBOARDING_LIMIT_SIGNING : CardTanSettingsRoutes.LIMIT_SIGNING);
    };

    if (store.isLoading) {
        return (
            <george.LoadingIndicator isLoading height={ui.windowHeight} />
        );
    }

    return (
        <>
            <SettingsTitleBar backRoute={CardTanSettingsRoutes.ROOT}><pr.H1_16_FFFFFF>{ui.__("sidentitySettings.navbar.selectLimit")}</pr.H1_16_FFFFFF></SettingsTitleBar>
            <george.BackgroundWithNavBar>
                <george.PageWithActionButton>
                    <Formsy.Form>
                        <ChooseSIdentityLimit
                            store={store}
                            name="sidentitylimit"
                        />
                        <george.ActionButton
                            onClick={handleChangeLimit}
                            primary
                            isLoading={isLoading}
                            messageId="sidentity.limit.actionbutton.text"
                            disableButton={!store.withoutLimit && !store.limit}
                        />
                    </Formsy.Form>
                </george.PageWithActionButton>
            </george.BackgroundWithNavBar>
        </>
    );
});



// WEBPACK FOOTER //
// ./src/components/loginManagement/cardTanSettings/CardTanSettingsLimit.tsx